import { Injectable } from "@angular/core";
import { Http } from "@angular/http";

@Injectable()
export class GetipService {
  constructor(private http: Http) {}

  getIpCliente() {
    return this.http
      .get("http://api.ipify.org/?format=json")
  }
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/getip/getip.service.ts